module.exports = __webpack_public_path__ + "img/gongjian.3c3e2bd8.png";